import { Link } from 'react-router-dom';
import { Star } from 'lucide-react';

const TopBar = () => {
  return (
    <div className="bg-[#14366C] text-white py-3" data-testid="top-bar">
      <div className="max-w-7xl mx-auto px-4 flex justify-center items-center">
        {/* Center - Stars + Read Our Reviews */}
        <Link to="/reviews" className="flex items-center gap-2 hover:text-[#F58220] transition-colors">
          <div className="flex gap-0.5">
            {[...Array(5)].map((_, i) => (
              <Star key={i} className="w-4 h-4 text-[#F5A623] fill-[#F5A623]" />
            ))}
          </div>
          <span className="text-sm font-medium">Read Our Reviews</span>
        </Link>
      </div>
    </div>
  );
};

export default TopBar;
